<div class="ui-g fondo">
    <div class="ui-g-2 ui-sm-1">
    </div>
    <div class="ui-g-8 ui-sm-12">
        <section class="beneficios">
            <div class="contenedor-beneficios">
                <div class="descripcion">
                    <div class="form">
                        <div class="titulo-center"><h2 class="titulo">Formulario de solicitud RPN <br> para personas individuales</h2></div>
                        <iframe class="form-inside" width="100%" height="1200" src="../../assets/individual.html">
                    </iframe>
                    </div>       
                </div>
            </div>
        </section>
    </div>
    <div class="ui-g-2 ui-sm-1"></div>
</div>



